import React from 'react'
import { Col, Container, Row, Card } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import CustomButton from '../CustomButton'
import { useNavigate } from 'react-router-dom'

const Banner = () => {

  const navigate = useNavigate()
  
  return (
    <div class="voloto-banner">
      <Container className='h-85'>
        <Row className=''>
          <Col lg={8} className=''>
            <SectionHeader mainText1="CSR"  />
            <h1>Corporate Social <br></br>Responsibility</h1>
            <p>Our Moments of Joy<br></br>Celebrating the smiles we create together.</p>
          </Col>
          <Col lg={4} className=''>
             <div className='card-shape'>

              <h3>Our approach to CSR is guided by three principles</h3>
              <h4><img src="images/star.svg" alt="tick" /><span>Empowering Communities</span></h4>
              <h4><img src="images/star.svg" alt="tick" /><span>Environmental Responsibility</span></h4>
              <h4><img src="images/star.svg" alt="tick" /><span>Employee Well-being</span></h4>
              <CustomButton buttonText="View Gallery" buttonType="FooterBtn" arrow onClick={()=> navigate('/gallery')} />
              </div>
          </Col>
        </Row>
      </Container>
      
     <img className='banner-vector' src="images/Union.svg" alt="vector" />
    </div>
  )
}

export default Banner
